<button (click)="toggleTimeMode()">
  Showing Times in {{ showLocalTime ? 'Local Time' : 'UTC' }}
</button>

<div *ngIf="tracking">
  <h3>Tracking Info</h3>
  <div *ngFor="let run of tracking; let i = index">
    <div class="tracking-row" *ngIf="i < trackingShowCount">
      <div>
        Start Time:
        {{ run.started_at | date:'medium':(showLocalTime ? undefined : 'UTC') }}
      </div>
      <div>
        End Time:
        {{ run.ended_at | date:'medium':(showLocalTime ? undefined : 'UTC') }}
      </div>
      <div>Run Time: {{ calculateGap(run.started_at, run.ended_at) }}</div>
      <div>People Found: {{ run.row_count }}</div>
    </div>
  </div>
  <button (click)="showMoreTracking(500)" *ngIf="trackingShowCount != tracking.length">Show More</button>
</div>

<div *ngIf="errors">
  <h3>Error Info</h3>
  <div *ngFor="let error of errors; let i = index">
    <div class="error-row" *ngIf="i < errorsShowCount">
      <div>
        Write Time:
        {{ error.time | date:'medium':(showLocalTime ? undefined : 'UTC') }}
      </div>
      <div>Error: {{ error.error }}</div>
    </div>
  </div>
  <button (click)="showMoreErrors(50)" *ngIf="errorsShowCount != errors.length">Show More</button>
</div>